<template>
  <div>
    <b-navbar toggleable="md" type="dark" variant="primary">
      <!-- <b-navbar toggleable="md" type="dark" variant="primary" class="fixed-top"> -->
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand href="#">ONE</b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="isLoggedIn"><a @click="logout">Logout</a></b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <router-view></router-view>
  </div>
</template>
<script>

// import LayoutHeader from '@/components/layout/Header'

export default {
  data () {
    return {}
  },
  computed : {
    isLoggedIn : function(){ return this.$store.getters.isLoggedIn}
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
      .then(() => {
        this.$router.push('/login')
      })
    }
  },
  created:function(){
    if(!this.$store.getters.isLoggedIn){
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login')
      })
    }
  }
}
</script>
<style>
body{
}
</style>